// @ts-nocheck
import { useEffect, useState } from 'react';
import { VoteRoomSlideOver } from './VoteRoomSlideOver';
import { ShutdownRuleForm } from '../shared/ShutdownRuleForm';

/**
 * Right-edge slide-over for viewing (post-launch) or editing shutdown rules on the live admin
 * dashboard. Pre-launch configuration lives in the setup wizard Shutdown Rule step.
 */
export const ShutdownSettingsSlideOver = ({ open, settings, onSave, onClose, readOnly = false }) => {
  const [mode, setMode] = useState(settings.mode);
  const [ct, setCt] = useState(settings.customThreshold || 90);
  const [hrs, setHrs] = useState(settings.hours || 48);

  useEffect(() => {
    if (open) {
      setMode(settings.mode);
      setCt(settings.customThreshold || 90);
      setHrs(settings.hours || 48);
    }
  }, [open, settings.mode, settings.customThreshold, settings.hours]);

  const footer = readOnly ? (
    <button
      type="button"
      onClick={onClose}
      className="px-3 py-1.5 rounded-md text-xs font-semibold bg-white text-gray-700 border border-gray-200 hover:bg-gray-50"
    >
      Close
    </button>
  ) : (
    <>
      <button type="button" onClick={onClose} className="px-3 py-1.5 text-xs font-medium text-gray-500">
        Cancel
      </button>
      <button
        type="button"
        onClick={() => {
          onSave({ mode, customThreshold: ct, hours: hrs });
          onClose();
        }}
        className="px-3 py-1.5 rounded-md text-xs font-semibold bg-[#0f172a] text-white hover:bg-[#1e293b]"
      >
        Save
      </button>
    </>
  );

  return (
    <VoteRoomSlideOver
      open={open}
      onClose={onClose}
      title="Shutdown Rule"
      titleId="vote-room-shutdown-slide-title"
      subtitle={
        readOnly ? 'Settings are read-only after launch.' : 'Choose when this Vote Room should close automatically.'
      }
      footer={footer}
    >
      <ShutdownRuleForm
        mode={mode}
        customThreshold={ct}
        hours={hrs}
        readOnly={readOnly}
        onModeChange={setMode}
        onCustomThresholdChange={setCt}
        onHoursChange={setHrs}
      />
    </VoteRoomSlideOver>
  );
};
